import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setGetListEvents } from '../../store/thunk/setGetListEvents';
import TemplatePage from '../../../components/templatePage';
import EventItem from '../../components/eventItem';
import { setLoadingAction } from '../../../components/templatePage/store/action';

const handleLoadPagination = ({page, setPage, countPage, dispatch}) => {
    if (page <= countPage) {
        dispatch(setGetListEvents({
            page: page + 1,
            rowsPerPage: 10
        }));
        setPage(page + 1);
    }
}

const handleLoading = (dispatch) => {
    dispatch(setLoadingAction(true))
}

const HistoryEvent = () => {
    const dispatch = useDispatch();
    const [page, setPage] = React.useState(1)

    React.useEffect(() => {
        dispatch(setGetListEvents({
            page: 1,
            rowsPerPage: 10
        }))
    }, [])

    const list = useSelector(state => state.adminMobile.events);

    return (
        <TemplatePage
            title="История действий"
            pagination={page < list.countPage && list.data.length}
            handleLoadPagination={() => handleLoadPagination({
                page,
                setPage,
                countPage: list.countPage,
                dispatch
            })}
            handleLoading={() => handleLoading(dispatch)}
        >
            {
                list.data.map((item, key, array) => <EventItem
                                                        item={item} 
                                                        keys={key} 
                                                        length={array.length} 
                                                    />)
            }
        </TemplatePage>
    )
}

export default HistoryEvent;